import { defineStore } from 'pinia';
import { ref } from 'vue';

export const useControlStore = defineStore('control', () => {
    // #region STATE

    const grids = ref([]);
    const activeTabId = ref(null);
    const controls = ref({});
    const checkAllUpdate = ref(false);
    const rail = ref(false);

    // #endregion

    // #region GRID
    
    //TODO: redo cleaner
    function isVisibleGrid(el) {
        if (!el)
            return false;

        // params.api.getGridElement() returns AG Grid's ".ag-styled-root"
        // wrapper, which is CSS "display: contents" (used only to carry theme
        // variables). Such an element never has a layout box of its own, so
        // both offsetWidth and getBoundingClientRect always report 0 on it -
        // that's the "constantly 0" symptom. ".ag-root-wrapper" underneath it
        // is AG Grid's actual boxed element, so measure that one instead.
        const measuredEl = el.querySelector('.ag-root-wrapper') || el;
        const rect = measuredEl.getBoundingClientRect();
        const isDisplayed = rect.width > 0 && rect.height > 0;

        if (!isDisplayed)
            return false;

        // ViewHome shows several grids at once, one per FlipCard, front/back.
        // A grid on the hidden face still has a non-zero bounding rect (CSS
        // transforms don't collapse layout), so width alone can't tell which
        // one is actually shown to the user - check the FlipCard's own state.
        const flipContainer = el.closest('.flip-container');

        if (flipContainer) {
            const isFlipped = flipContainer.classList.contains('flipped');
            const isOnBackFace = !!el.closest('.back');

            return isOnBackFace === isFlipped;
        }

        return true;
    }

    function getDisplayedGrid() {
        let displayedGrid = null;

        grids.value.forEach((grid) => {
            if (isVisibleGrid(grid.dom))
                displayedGrid = grid;
        });

        return displayedGrid;
    }

    function undoAll() {
        const gridApi = getDisplayedGrid().api;

        for (let i = 0; i < gridApi.getCurrentUndoSize() + 1; i++)
            setTimeout(() => {
                gridApi.undoCellEditing();
            }, 10 * i);

        gridApi.redrawRows();
    }

    function checkAll(column) {
        checkAllUpdate.value = true;

        const field = column.parentElement.parentElement.parentElement.parentElement.attributes['col-id'].value;
        const checkbox = window.$('.checkbox-all input');
        checkbox.removeAttr('data-indeterminate');
        const isChecked = checkbox.prop('checked');

        const gridApi = getDisplayedGrid().api;
        const rowData = [];

        gridApi.forEachLeafNode((node) => {
            node.data[field] = isChecked;
            rowData.push(node.data);
        });

        gridApi.applyTransaction({
            update: rowData,
        });

        if (typeof controls.value.saveUsersButton !== 'undefined')
            window.$(controls.value.saveUsersButton.root).enable();

        setTimeout(() => {
            checkAllUpdate.value = false;
        }, 1000);
    }

    // #endregion

    // #region TABS

    function setActiveTab(newActiveTabId) {
        activeTabId.value = newActiveTabId;
    }

    function getActiveTab() {
        return activeTabId.value;
    }

    // #endregion

    return {
        // state
        grids,
        activeTabId,
        controls,
        checkAllUpdate,
        rail,
        // grid
        isVisibleGrid,
        getDisplayedGrid,
        undoAll,
        checkAll,
        // tabs
        setActiveTab,
        getActiveTab,
    };
});
